import React from 'react';

/** Numbered step card used by the Buy guides. */
const StepCard = ({ n, title, children }) => (
  <li className="card flex items-start gap-3 lg:gap-4">
    <span className="flex h-[42px] w-[42px] shrink-0 items-center justify-center rounded-full border-[3px] border-ink bg-sun text-lg font-bold">{n}</span>
    <div className="min-w-0 flex-1">
      <h3 className="text-xl font-bold leading-tight lg:text-2xl">{title}</h3>
      <div className="mt-1.5 grid gap-2 text-[15px] lg:text-base">{children}</div>
    </div>
  </li>
);

/** Chunky outbound link tile (DEX, wallet guide, etc.). */
export const LinkTile = ({ href, title, sub }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className="flex items-center justify-between gap-3 rounded-2xl border-[3px] border-ink bg-paper px-4 py-3 no-underline shadow-hard transition-transform hover:-translate-y-0.5 active:translate-x-0.5 active:translate-y-0.5 active:shadow-none"
  >
    <span className="min-w-0">
      <span className="block text-base font-bold">{title}</span>
      {sub && <span className="block text-sm text-muted">{sub}</span>}
    </span>
    <span className="shrink-0 text-lg font-bold" aria-hidden="true">
      ↗
    </span>
  </a>
);

/** Non-interactive info tile (e.g. wallet suggestions). */
export const InfoTile = ({ title, sub }) => (
  <div className="rounded-2xl border-2 border-ink bg-sand px-4 py-3">
    <span className="block text-base font-bold">{title}</span>
    {sub && <span className="block text-sm text-muted">{sub}</span>}
  </div>
);

export default StepCard;
